<template>
  <div
    style="
      background: #f5f5f5;
      background-image: url('../../../static/img/Background4.jpg');
      background-repeat: round;
    "
  >
    <div class="father_div_bg">
      <div class="selectbox">
        <img src="../../../static/img/48.png" class="jiantou" />
        <span class="cur" @click="navto('/Product')">{{
          language == "zh" ? "产品中心" : "Products"
        }}</span>
        <span class="fenge">></span>
        <span
          class="cur"
          @click="navto('/ProductDetail?type1=' + detail.type1)"
          >{{ language == "zh" ? type1 : type1En }}</span
        >
        <span class="fenge">></span>
        <span
          class="cur"
          v-if="type2"
          @click="
            navto(
              '/ProductDetail?type2=' + detail.type2 + '&type1=' + detail.type1
            )
          "
          >{{ language == "zh" ? type2 : type2En }}</span
        >
        <span class="fenge" v-if="type2">></span>
        <span
          class="cur"
          v-if="type3"
          @click="
            navto(
              '/ProductDetail?type2=' +
                detail.type2 +
                '&type1=' +
                detail.type1 +
                '&type3=' +
                detail.type3
            )
          "
          >{{ language == "zh" ? type3 : type3En }}</span
        >
        <span class="fenge" v-if="type3">></span>
        <span class="cur">{{ detail.model }}</span>
        <transition
          appear
          name="animate__animated animate__bounce"
          enter-active-class="animate__fadeIn"
          leave-active-class="animated__fadeOut"
        >
          <div v-show="isShow" class="keyinput">
            <el-autocomplete
              class="inline-input"
              v-model="input"
              :fetch-suggestions="querySearch"
              :placeholder="language == 'zh' ? '请输入内容' : 'please input'"
              style="width: 300px"
              @select="handleSelect"
              :trigger-on-focus="false"
            ></el-autocomplete>
          </div>
        </transition>
        <img
          src="../../../static/img/5.png"
          class="sousuo"
          @click="isShow = !isShow"
        />
      </div>
      <el-row :gutter="50" class="product-menu">
        <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" class="left">
          <el-row :gutter="25" class="left-img">
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div class="bg">
                <img :src="detail.picPd" class="ylt" />
                <div>
                  {{ language == "zh" ? "产品图" : "Product Overview" }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
              <div class="bg">
                <img :src="detail.symbol" class="ylt" />
                <div>{{ language == "zh" ? "原理图" : "Symbol" }}</div>
              </div>
            </el-col>
          </el-row>
          <div class="menu dtbox">
            <div class="dt">
              <!-- <el-image-viewer
            :src="detail.picSize"
            ref="previewImg" 
            >
          </el-image-viewer> -->
              <el-image
                v-show="language == 'zh'"
                :zIndex="9999"
                ref="previewImg"
                :src="detail.picSize"
                :preview-src-list="srcList"
              >
                <div slot="placeholder" class="image-slot">
                  <i class="el-icon-loading"></i>加载中
                </div>
              </el-image>
              <el-image
                v-show="language == 'en'"
                :zIndex="9999"
                ref="previewImgEn"
                :src="detail.picSizeEn"
                :preview-src-list="srcListEn"
              >
                <div slot="placeholder" class="image-slot">
                  <i class="el-icon-loading"></i>加载中
                </div>
              </el-image>
              <img
                src="../../../static/img/72.png"
                class="fdj"
                @click="previewImg"
              />
              <div>{{ language == "zh" ? "尺寸图" : "Dimensions" }}</div>
            </div>
          </div>
          <div class="menu callus show_pc">
            <div class="text">
              {{ language == "zh" ? "联系我们" : "Contact us" }}
            </div>
            <div class="tel">
              <img src="../../../static/img/50.png" /> {{ contact.tel }}
            </div>
            <div class="email">
              <img src="../../../static/img/49.png" />{{ contact.email }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14" class="right">
          <div class="Introduce">
            <div class="name_div">
              <p class="name">
                {{ detail.model }}
              </p>
              <img
                v-if="filelist.length > 0"
                src="../../../static/img/76.png"
                @click="language=='zh'?download(filelist[0]):download(filelistEn[0])"
              />
              <!-- <img
                src="../../../static/img/76.png"
                v-for="(item, index) in filelist"
                :key="index"
                @click="download(item)"
              /> -->
              <!-- <img v-else src="../../../static/img/73.png"/> -->
            </div>
            <div class="nameI" v-html="language == 'zh' ? detail.key : detail.keyEn">
            </div>
            <div class="detail">
              <div class="item" v-if="detail.cavity">
                <span class="title">{{
                  language == "zh" ? "插孔" : "Cavity"
                }}</span
                >:
                <span class="val">{{ detail.cavity }}</span>
              </div>
              <div class="item" v-if="detail.flow">
                <span class="title">{{
                  language == "zh" ? "流量" : "Flow"
                }}</span
                >:
                <span class="val">{{ detail.flow }} L/min</span>
              </div>
              <div class="item" v-if="detail.pressure">
                <span class="title">{{
                  language == "zh" ? "工作压力" : "Pressure"
                }}</span
                >:
                <span class="val">{{ detail.pressure }} bar</span>
              </div>
              <div class="heng"></div>
              <div class="item">
                <span class="title">{{
                  language == "zh" ? "描述" : "Description"
                }}</span
                >:
                <span class="val" v-html="language == 'zh' ? detail.description : detail.descriptionEn"></span>
                
              </div>
            </div>
            <el-collapse
              v-model="activeName"
              class="sfq"
              @change="handleChange"
            >
              <el-collapse-item
                name="1"
                v-if="detail.detail1"
                @mouseenter.native="hover1 = true"
                @mouseout.native="hover1 = false"
              >
                <template slot="title">
                  <img
                    src="../../../static/img/80.png"
                    class="icon"
                    v-if="activeName.indexOf('1') >= 0 || hover1"
                  />
                  <img src="../../../static/img/64.png" class="icon" v-else />{{
                    language == "zh" ? "原理特点" : "OPERATION & FEATRUES"
                  }}
                </template>
                <div
                  class="v-html editor-content-view"
                  v-html="language == 'zh' ? detail.detail1 : detail.detail1En"
                ></div>
              </el-collapse-item>
              <el-collapse-item
                name="2"
                v-if="detail.detail2"
                @mouseenter.native="hover2 = true"
                @mouseout.native="hover2 = false"
              >
                <template slot="title">
                  <img
                    src="../../../static/img/65.png"
                    class="icon"
                    v-if="activeName.indexOf('2') >= 0 || hover2"
                  />
                  <img src="../../../static/img/89.png" class="icon" v-else />{{
                    language == "zh" ? "技术参数" : "TECHNICAL DATA"
                  }}
                </template>
                <div
                  class="v-html editor-content-view"
                  v-html="language == 'zh' ? detail.detail2 : detail.detail2En"
                ></div>
              </el-collapse-item>
              <el-collapse-item
                name="3"
                v-if="detail.detail3"
                @mouseenter.native="hover3 = true"
                @mouseout.native="hover3 = false"
              >
                <template slot="title">
                  <img
                    src="../../../static/img/82.png"
                    class="icon"
                    v-if="activeName.indexOf('3') >= 0 || hover3"
                  />
                  <img src="../../../static/img/66.png" class="icon" v-else />{{
                    language == "zh" ? "性能曲线" : "PERFORMANCE CURVES"
                  }}
                </template>
                <div
                  class="v-html editor-content-view"
                  v-html="language == 'zh' ? detail.detail3 : detail.detail3En"
                ></div>
              </el-collapse-item>
              <el-collapse-item
                name="4"
                v-if="detail.detail4"
                @mouseenter.native="hover4 = true"
                @mouseout.native="hover4 = false"
              >
                <template slot="title">
                  <img
                    src="../../../static/img/87.png"
                    class="icon"
                    v-if="activeName.indexOf('4') >= 0 || hover4"
                  />
                  <img src="../../../static/img/71.png" class="icon" v-else />{{
                    language == "zh" ? "订购选型" : "ORDERING CODE"
                  }}
                </template>
                <div
                  class="v-html editor-content-view"
                  v-html="language == 'zh' ? detail.detail4 : detail.detail4En"
                ></div>
              </el-collapse-item>
              <el-collapse-item
                name="5"
                v-if="detail.detail5"
                @mouseenter.native="hover5 = true"
                @mouseout.native="hover5 = false"
              >
                <template slot="title">
                  <img
                    src="../../../static/img/86.png"
                    class="icon"
                    v-if="activeName.indexOf('5') >= 0 || hover5"
                  />
                  <img src="../../../static/img/70.png" class="icon" v-else />{{
                    language == "zh" ? "文件下载" : "FILES DOWNLOAD"
                  }}
                </template>
                <div
                  class="v-html editor-content-view"
                  v-html="language == 'zh' ? detail.detail5 : detail.detail5En"
                ></div>
              </el-collapse-item>
              <el-collapse-item
                name="6"
                v-if="detail.detail6"
                @mouseenter.native="hover6 = true"
                @mouseout.native="hover6 = false"
              >
                <template slot="title">
                  <img
                    src="../../../static/img/83.png"
                    class="icon"
                    v-if="activeName.indexOf('6') >= 0 || hover6"
                  />
                  <img src="../../../static/img/67.png" class="icon" v-else />{{
                    language == "zh" ? "线圈信息" : "COIL INFORMATION"
                  }}
                </template>
                <div
                  class="v-html editor-content-view"
                  v-html="language == 'zh' ? detail.detail6 : detail.detail6En"
                ></div>
              </el-collapse-item>
              <el-collapse-item
                name="7"
                v-if="detail.detail7"
                @mouseenter.native="hover7 = true"
                @mouseout.native="hover7 = false"
              >
                <template slot="title">
                  <img
                    src="../../../static/img/84.png"
                    class="icon"
                    v-if="activeName.indexOf('7') >= 0 || hover7"
                  />
                  <img src="../../../static/img/68.png" class="icon" v-else />{{
                    language == "zh" ? "相关辅件" : "RELATED ACCESSORIES"
                  }}
                </template>
                <div
                  class="v-html editor-content-view"
                  v-html="language == 'zh' ? detail.detail7 : detail.detail7En"
                ></div>
              </el-collapse-item>
              <el-collapse-item
                name="8"
                v-if="detail.detail8"
                @mouseenter.native="hover8 = true"
                @mouseout.native="hover8 = false"
              >
                <template slot="title">
                  <img
                    src="../../../static/img/85.png"
                    class="icon"
                    v-if="activeName.indexOf('8') >= 0 || hover8"
                  />
                  <img src="../../../static/img/69.png" class="icon" v-else />{{
                    language == "zh" ? "其他说明" : "OTHER NOTES"
                  }}
                </template>
                <div
                  class="v-html editor-content-view"
                  v-html="language == 'zh' ? detail.detail8 : detail.detail8En"
                ></div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
      </el-row>
      <div class="Mymenu callus show_phone">
          <div class="text">
            {{language=='zh'?'联系我们':'Contact us'}}
          </div>
          <div class="tel">
           <img src="../../../static/img/50.png" /> {{contact.tel}}
          </div>
          <div class="email">
            <img src="../../../static/img/49.png" />{{contact.email}}
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "Product",
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      input: "",
      isShow: false,
      detail: {},
      activeName: [],
      type1: "",
      type1En: "",
      contact: {},
      type2: "",
      type3: "",
      type2En: "",
      type3En: "",
      srcList: [],
      srcListEn: [],
      currentPage: 1,
      tags: [],
      icon: "el-icon-plus",
      hover1: false,
      hover2: false,
      hover3: false,
      hover4: false,
      hover5: false,
      hover6: false,
      hover7: false,
      hover8: false,
      hover9: false,
      menu: [],
      filelist: [],
      filelistEn: [],
    };
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.input = "";
      if (to.fullPath.indexOf("ProductIntroduce") >= 0) {
        this.getInfo();
        this.getInfo1();
      }
      // this.$parent.hideSearch = from.fullPath.indexOf('Product') >= 0?true:false
    },
  },
  mounted() {
    this.getInfo();
    this.getInfo1();
  },
  methods: {
    querySearch(queryString, cb) {
      let params = {
        key: this.input,
        page: 1,
        limit: 999,
      };
      this.$http
        .get("/hdbs/api/product/list", {
          params,
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              let restaurant = [];
              let temp_arr = [];
              response.data.data.list.map((data) => {
                var typeNameList = data.typeName.split("/");
                var typeNameListEn = data.typeNameEn.split("/");
                console.log(typeNameList);
                if (data.type1) {
                  let d = typeNameList[0];
                  if (this.language == "en") {
                    d = typeNameListEn[0];
                  }
                  if (temp_arr.indexOf(d) == -1) {
                    temp_arr.push(d);
                    restaurant.push({ value: d, code: 1, type1: data.type1 });
                  }
                }
                if (data.type2) {
                  let d = typeNameList[0] + ">" + typeNameList[1];
                  if (this.language == "en") {
                    d = typeNameListEn[0] + ">" + typeNameListEn[1];
                  }
                  if (temp_arr.indexOf(d) == -1) {
                    temp_arr.push(d);
                    restaurant.push({
                      value: d,
                      code: 2,
                      type1: data.type1,
                      type2: data.type2,
                    });
                  }
                }
                if (data.type3) {
                  let d =
                    typeNameList[0] +
                    ">" +
                    typeNameList[1] +
                    ">" +
                    typeNameList[2];
                  if (this.language == "en") {
                    d =
                      typeNameListEn[0] +
                      ">" +
                      typeNameListEn[1] +
                      ">" +
                      typeNameListEn[2];
                  }
                  if (temp_arr.indexOf(d) == -1) {
                    temp_arr.push(d);
                    restaurant.push({
                      value: d,
                      code: 3,
                      type1: data.type1,
                      type2: data.type2,
                      type3: data.type3,
                    });
                  }
                }
                let d = data.key + "(" + data.model + ")";
                if (this.language == "en") {
                  d = data.keyEn + "(" + data.model + ")";
                }
                restaurant.push({
                  value: d,
                  code: 4,
                  id: data.id,
                });
              });
              // 调用 callback 返回建议列表的数据
              cb(restaurant);
            }
          }.bind(this)
        );
    },
    handleSelect(item) {
      if (item.code == 4) {
        this.$router.push("/ProductIntroduce?id=" + item.id);
      } else if (item.code == 1) {
        this.$router.push("/ProductDetail?type1=" + item.type1);
      } else if (item.code == 2) {
        this.$router.push(
          "/ProductDetail?type1=" + item.type1 + "&type2=" + item.type2
        );
      } else if (item.code == 3) {
        this.$router.push(
          "/ProductDetail?type1=" +
            item.type1 +
            "&type2=" +
            item.type2 +
            "&type3=" +
            item.type3
        );
      }
    },
    previewImg() {
      if(this.language=='zh'){

        this.$refs.previewImg.showViewer = true;
      }else{

        this.$refs.previewImgEn.showViewer = true;
      }
    },
    mouseEnter() {
      console.log("HHHH");
    },
    handleChange() {
      console.log("HH" + this.activeName);
      // if(this.activeName.indexOf('5')>=0){
      //   this.download(this.detail.detail5)
      //   this.activeName=[];
      // }
    },
    download(url) {
      window.open(url);
    },
    downloadAll(url) {
      // console.log("dooo" + url);
      for (var i = 0; i <= this.filelist.length; i++) {
        console.log("dooo" + this.filelist[i]);
        this.downloads(this.filelist[i]);
      }
    },

    downloads(url) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      function iframeLoad() {
        console.log("iframe onload");
        const win = iframe.contentWindow;
        const doc = win.document;
        if (win.location.href === url) {
          if (doc.body.childNodes.length > 0) {
            // response is error
          }
          iframe.parentNode.removeChild(iframe);
        }
      }
      if ("onload" in iframe) {
        iframe.onload = iframeLoad;
      } else if (iframe.attachEvent) {
        iframe.attachEvent("onload", iframeLoad);
      } else {
        iframe.onreadystatechange = function onreadystatechange() {
          if (iframe.readyState === "complete") {
            iframeLoad;
          }
        };
      }
      iframe.src = "";
      document.body.appendChild(iframe);
      setTimeout(function loadUrl() {
        iframe.contentWindow.location.href = url;
      }, 50);
    },
    getTree() {
      this.$http.get("/hdbs/api/product/type/tree", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.menu = response.data.data;
            let list1 = response.data.data.filter((c) => {
              return c.value == this.detail.type1;
            })[0];
            this.type1 = list1.label;
            this.type1En = list1.labelEn;
            let list2 = list1.children.filter((c) => {
              return c.value == this.detail.type2;
            });
            if (list2.length > 0) {
              this.type2 = list2[0].label;
              this.type2En = list2[0].labelEn;
            } else {
              this.type2 = "";
              this.type2En = "";
              this.type3 = "";
              this.type3En = "";
            }
            // console.log(list1)
            // console.log(list2)
            let list3 = [];
            if (list2[0].children) {
              list3 = list2[0].children.filter((c) => {
                return c.value == this.detail.type3;
              });
            }
            // console.log(list3)
            if (list3.length > 0 && this.detail.type3) {
              this.type3 = list3[0].label;
              this.type3En = list3[0].labelEn;
            } else {
              this.type3 = "";
              this.type3En = "";
            }
          }
        }.bind(this)
      );
    },
    getInfo() {
      // this.type1 = ''
      // this.type1En = ''
      // this.type2 = ''
      // this.type2En = ''
      // this.type3 = ''
      // this.type3En = ''
      this.filelist.length = 0;
      this.$http
        .get(
          "/hdbs/api/product/info/" + window.location.href.split("?id=")[1],
          {}
        )
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.detail = response.data.data;
              // this.detail = this.replaceStr(response.data.data);
              var content = this.detail;
              this.getUrlformHtml(content);
              // document.getElementById('editor-content-view').innerHTML = this.detail.detail2En
              this.srcList = [this.detail.picSize];
              this.srcListEn = [this.detail.picSizeEn];
              this.getTree();
            }
          }.bind(this)
        );
    },
    //从富文本中取出url
    getUrlformHtml(content){
      if (content) {
                console.log(content);
                var contentZh = content.detail5;
                var contentEn = content.detail5En;
                  var reg = /(https?:\/{2}[^\s]*)/g;
                if(contentZh){
                  console.log(contentZh.match(reg));
                  
                  let list = contentZh.match(reg);
                  for (var i = 0; i < list.length; i++) {
                  var item = list[i];
                  var newitem = item.replace('"', "");
                  console.log(item);
                  if (newitem.endsWith("pdf")) {
                    this.filelist.push(newitem);
                  }
                }
                }
                if(contentEn){

                  let listEn = contentEn.match(reg);
                  for (var i = 0; i < listEn.length; i++) {
                  var item = listEn[i];
                  var newitem = item.replace('"', "");
                  console.log(item);
                  if (newitem.endsWith("pdf")) {
                    this.filelistEn.push(newitem);
                  }
                }
                }
                
                
              }
    },
    replaceStr(str){
      console.log(str)
      const searchRegExp = /-/g
      const replaceWith = '-'
      const result = str.replace(searchRegExp, replaceWith)
      return result;
    },
    getInfo1() {
      this.$http.get("/hdbs/api/contacts/company", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.contact = response.data.data[0];
          }
        }.bind(this)
      );
    },
    navto(url) {
      this.$router.push(url);
    },
    handleNodeClick(data) {
      if (data.tagable) {
        let name = data.pName + "：" + data.name;
        if (this.tags.indexOf(name) >= 0) {
          return false;
        } else {
          this.tags.push(name);
        }
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
    },
    rowClick(row) {
      this.$router.push("/ProductIntroduce" + id);
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.Mymenu{
  width: 100%;
  padding: 3.5rem 2rem;
  background: #fff;
  border-radius: 6px;
  font-size: 1.7rem;
  margin-bottom: 3rem;
  box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
    .biaoti{
      color: var(--mainBlue);
      margin-bottom: 3rem;
      font-size: 2.7rem;
      margin-left: 2.5rem;
      font-family: Demibold;
    }
}
.show_pc {
  display: block;
}
.show_phone {
  display: none;
}
.selectbox {
  background: #fff;
  border-radius: 6px;
  margin: 4vh 0;
  padding: 2rem;
  position: relative;
  font-family: Regular;
  display: flex;
  font-size: 1.7rem;
  align-items: center;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
  color: var(--mainGary);

  .cur {
    cursor: pointer;
  }

  .cur:hover {
    color: #024580;
  }

  .fenge {
    padding: 0 10px;
  }

  .jiantou {
    width: 6px;
    margin-right: 20px;
  }

  .sousuo {
    width: 15px;
    position: absolute;
    right: 20px;
    cursor: pointer;
  }

  .keyinput {
    position: absolute;
    right: 10px;
  }
}

.dtbox {
  padding: 10px;
  font-size: 1.7rem;
  text-align: center;
  color: #024580;
  position: relative;
}

.fdj {
  cursor: pointer;
  position: absolute;
  width: 18px;
  bottom: 15px;
  right: 15px;
}

.callus {
  margin-top: 3rem;
  padding: 3.5rem 2rem;
  font-size: 1.7rem;

  .text {
    color: #024580;
    margin-bottom: 2rem;
    margin-left: 2.5rem;
  }

  .tel {
    display: flex;
    align-items: center;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }

  .email {
    display: flex;
    align-items: center;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }
}

.product-menu {
  margin: 0 !important;

  .left {
    padding-left: 0 !important;

    .menu {
      background: #fff;
      border-radius: 6px;
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
      margin-bottom: 25px;
    }

    .bg {
      background: #fff;
      border-radius: 6px;
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
      margin-bottom: 25px;
      height: 28rem;
      text-align: center;
      color: #024580;
      font-size: 1.7rem;

      img.ylt {
        width: 100%;
        height: 85%;
        object-fit: contain;
      }

      .biaoti {
        color: #024580;
        font-weight: 600;
        padding: 1vw 0 0 1vw;
        font-size: 1.7rem;
      }

      .line {
        width: 80%;
        height: 1px;
        margin-left: 10%;
        background: #e4e7ed;
      }
    }
  }

  .right {
    background: #fff;
    border-radius: 6px;
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
    margin-bottom: 6vh;

    .Introduce {
      padding: 1.5vw;
      color: var(--mainGary);

      .name_div {
        display: flex;

        img {
          cursor: pointer;
          width: 2.5rem;
          margin-left: 2rem;
          height: auto;
          object-fit: contain;
        }

        .name {
          font-size: 3.2rem;
          font-family: Demibold;
          line-height: 1;
          margin: 0;
        }
      }

      .nameI {
        margin-top: 1rem;
        font-size: 2.7rem;
        font-family: Demibold;
      }

      .detail {
        margin-top: 5rem;
        font-size: 1.7rem;

        .val {
          color: #727171b0;
        }

        .heng {
          margin: 10px 0;
          width: 100%;
          height: 1px;
          background: #e4e7ed;
        }
      }
    }

    .sfq {
      margin-top: 4rem;

      /deep/ .el-collapse-item__header:hover {
        color: #024580;
        font-family: Demibold;
      }

      /deep/ .el-collapse-item__header {
        font-size: 1.7rem;
      }

      /deep/ .el-collapse-item__header.is-active {
        color: #024580;
        font-family: Demibold;
        border: 1px solid #EBEEF5;
        background-color: #fff !important;
        box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
      }

      .icon {
        width: 20px;
        margin-right: 1vw;
      }
    }

    /deep/ .el-collapse {
      border-top: 0;
      border-bottom: 0;
    }
  }
}

.father_div_bg {
  padding: 0 20rem;
  border-radius: 6px;
  height: 100%;
}

.v-html {
  width: 100%;

  p {
    margin-bottom: 0 !important;
  }

  /deep/ .el-collapse-item__content {
    color: var(--mainGary);
  }

  ul {
    li {
      color: var(--mainGary);
    }
  }
}

/deep/ .el-collapse-item__content {
  color: var(--mainGary);
  font-size: 1.7rem;
}

@media screen and (max-width: 1400px) {
  .father_div_bg {
    padding: 0 1rem;
  }
}
@media screen and (max-width: 1000px) {
  
  .selectbox{
    margin-top:-4vh;
  }
  .show_pc {
    display: none;
  }
  .show_phone {
    display: block;
  }
  .product-menu .left{
    margin-top:0;
    padding-right: 0 !important;
  }
  .product-menu .right{
    margin-top:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductII.vue